/*
 * Noma Desk product page - tier selection only.
 *
 * Every price on the page is rendered by Liquid and parked on the radio as a
 * data attribute, so this file never formats money and never guesses a
 * currency. Selecting a tier copies those values into the form: the hidden
 * [name="id"] input, the hidden quantity input, the legend, the price inside
 * the button. The cart POST itself belongs to
 * Dawn's <product-form> element and is not touched here.
 */
(function () {
  'use strict';

  function setText(el, value) {
    if (el) el.textContent = value;
  }

  /* Keep the standalone price/saving line in sync with what the customer
   * is actually buying. The selected tier supplies the base price and
   * retotal() adds any paid add-ons, including their compare-at values. */
  function updatePricePill(root, radio, nowCents, wasCents, sample) {
    var pill = root.querySelector('[data-nd-price-pill]');
    if (!pill || !radio) return;

    if (typeof nowCents !== 'number') {
      nowCents = Number(radio.getAttribute('data-nd-total-cents')) || 0;
    }
    if (typeof wasCents !== 'number') {
      wasCents = Number(radio.getAttribute('data-nd-was-cents')) || 0;
    }

    sample = sample || '$0';

    var now = formatMoney(nowCents, sample);
    var was = wasCents > nowCents ? formatMoney(wasCents, sample) : '';
    var prefix = pill.getAttribute('data-save-prefix') || 'Save';

    setText(pill.querySelector('[data-nd-price-pill-now]'), now);

    var wasEl = pill.querySelector('[data-nd-price-pill-was]');
    if (wasEl) {
      setText(wasEl, was);
      wasEl.hidden = !(wasCents > nowCents && was !== '');
    }

    var badge = pill.querySelector('[data-nd-price-pill-badge]');
    if (badge) {
      var pct = wasCents > nowCents && wasCents > 0
        ? Math.round(((wasCents - nowCents) * 100) / wasCents)
        : 0;
      setText(badge, pct > 0 ? prefix + ' ' + pct + '%' : '');
      badge.hidden = pct <= 0;
    }
  }

  function apply(root, radio) {
    if (!radio) return;

    var idInput = root.querySelector('[data-nd-variant-id]');
    var qtyInput = root.querySelector('[data-nd-quantity]');
    var submit = root.querySelector('[data-nd-submit]');

    var available = !radio.disabled;

    if (idInput) {
      idInput.value = radio.getAttribute('data-nd-variant-value');
      idInput.disabled = !available;
    }

    if (qtyInput) {
      qtyInput.value = radio.getAttribute('data-nd-quantity-value') || '1';
    }

    setText(root.querySelector('[data-nd-tier-value]'), radio.getAttribute('data-nd-label') || '');
    setText(root.querySelector('[data-nd-total]'), radio.getAttribute('data-nd-total-value') || '');

    /* What comes free with this tier. Hidden rather than emptied, so a tier
       that includes nothing leaves no gap above the button. */
    var gift = root.querySelector('[data-nd-gift]');
    if (gift) {
      var giftText = radio.getAttribute('data-nd-gift-value') || '';
      setText(gift.querySelector('[data-nd-gift-text]'), giftText);
      gift.hidden = giftText === '';
    }
    giftNote = gift;

    /* After the gift note, so retotal can stand it down when the add-on
       cards already show the gift as free. */
    retotal(root);

    if (submit) {
      submit.disabled = !available;
    }

    var tiers = root.querySelectorAll('[data-nd-tier]');
    for (var i = 0; i < tiers.length; i++) {
      var tile = tiers[i].closest ? tiers[i].closest('.nd-tier') : tiers[i].parentNode;
      if (!tile) continue;
      if (tiers[i] === radio) {
        tile.classList.add('is-selected');
      } else {
        tile.classList.remove('is-selected');
      }
    }
  }

  /* Money, in the shop's own format.
   *
   * The add-ons change the total, so the figure on the button has to be
   * built in the browser -- and a hardcoded "$" would be wrong the moment
   * anyone switches currency. The pattern is read off a zero rendered by
   * Liquid: whatever sits before the first digit is the prefix and
   * whatever follows the last is the suffix, which covers $, A$, kr and
   * the ones that put the symbol after the number. */
  function formatMoney(cents, sample) {
    var digits = /[0-9]/;
    var first = -1;
    var last = -1;
    var i;

    for (i = 0; i < sample.length; i++) {
      if (digits.test(sample[i])) {
        if (first === -1) first = i;
        last = i;
      }
    }

    var prefix = first > 0 ? sample.slice(0, first) : '';
    var suffix = last > -1 && last < sample.length - 1 ? sample.slice(last + 1) : '';
    var whole = cents / 100;
    var body = whole % 1 === 0 ? String(whole) : whole.toFixed(2);

    /* Thousands, the way the rest of the page writes them. */
    body = body.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return prefix + body + suffix;
  }

  /* The button says what the button will charge.
   *
   * A tier price plus whatever is ticked. Without this the button reads
   * $159 and takes $189, which is the one number on the page that is not
   * allowed to be approximate. */
  var giftNote = null;

  function retotal(root) {
    var out = root.querySelector('[data-nd-total]');
    var radio = root.querySelector('[data-nd-tier]:checked');
    if (!out || !radio) return;

    var base = Number(radio.getAttribute('data-nd-total-cents'));
    if (!base && base !== 0) return;

    var baseWas = Number(radio.getAttribute('data-nd-was-cents')) || 0;
    var baseReference = baseWas > base ? baseWas : base;

    var panel = document.querySelector('[data-nd-addons]');
    var boxes = panel ? panel.querySelectorAll('[data-nd-addon]') : [];
    var sample = (panel && panel.getAttribute('data-money-zero')) || '$0';

    /* One accessory per desk.
     *
     * Buying the 3-pack and adding a mouse pad means three mouse pads --
     * which is what someone buying three setups wants, and the only
     * reading under which the row is called Add-ons rather than Extras.
     * The multiplier is shown on the card, because a card reading +$10
     * beside a button that moves $30 is the same lie in miniature. */
    var qty = Number(radio.getAttribute('data-nd-quantity-value')) || 1;

    /* What this tier already gives away is not also for sale. A tier can
       now include two different gifts (for example MousePad + Keyboard Lift). */
    var giftProducts = [
      radio.getAttribute('data-nd-gift-product') || '',
      radio.getAttribute('data-nd-gift-product-2') || ''
    ].filter(function (id) { return id !== ''; });

    var extra = 0;
    var extraReference = 0;
    var ticked = 0;
    var live = 0;
    var giftOnCard = false;
    var i;

    for (i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var cell = box.closest ? box.closest('.nd-addons__cell') : null;
      var addonProduct = box.getAttribute('data-product') || '';
      var isGift = giftProducts.indexOf(addonProduct) !== -1;

      var free = box.parentNode.querySelector('[data-nd-free]');
      var freeText = box.parentNode.querySelector('[data-nd-free-text]');

      if (cell) cell.classList.toggle('is-gift', isGift);

      if (isGift) {
        /* It stays on the row and says it is free. Removing it hid the
           best thing about this tier at the exact moment someone is
           pricing accessories -- and unticked, so a pack switch cannot
           leave it quietly adding itself to the order at full price. */
        box.checked = false;
        box.disabled = true;
        if (free) free.hidden = false;
        if (freeText) freeText.textContent = '\u00d7' + qty + ' free';
        giftOnCard = true;
        continue;
      }

      box.disabled = false;
      if (free) free.hidden = true;
      live++;

      var each = Number(box.getAttribute('data-cents')) || 0;
      var compareEach = Number(box.getAttribute('data-compare-cents')) || 0;
      var referenceEach = compareEach > each ? compareEach : each;
      var mult = box.parentNode.querySelector('[data-nd-mult]');
      var delta = box.parentNode.querySelector('[data-nd-delta]');
      var was = box.parentNode.querySelector('[data-nd-was]');

      if (delta) delta.innerHTML = '+&nbsp;' + formatMoney(each * qty, sample);
      if (mult) {
        mult.textContent = '\u00d7' + qty;
        mult.hidden = qty < 2;
      }
      /* A compare-at only reads as a saving against a single unit. */
      if (was) was.hidden = qty > 1;

      if (box.checked) {
        extra += each * qty;
        extraReference += referenceEach * qty;
        ticked++;
      }
    }

    var totalNow = base + extra;
    var totalWas = baseReference + extraReference;

    out.textContent = formatMoney(totalNow, sample);

    /* The separate price-with-saving line must tell the same story as the
       button. On the single option, ticking Keyboard Lift and/or MousePad
       increases the live price and also adds their compare-at prices to the
       reference total, so the SAVE % remains truthful. */
    updatePricePill(
      root,
      radio,
      totalNow,
      totalWas > totalNow ? totalWas : 0,
      sample
    );

    /* Said once. The card carries the gift in the row where someone is
       pricing accessories, which is the better place for it, so the note
       above the button stands down rather than repeating it 40px later.
       It still appears for a gift that is not one of the add-ons. */
    if (giftNote && giftOnCard) giftNote.hidden = true;

    /* The pair line is a fact about the current selection, so it appears
       only while the selection makes it true -- and only while there are
       still two things to pair. */
    var pair = panel && panel.querySelector('[data-nd-pair]');
    if (pair) pair.hidden = !(live > 1 && ticked === live);
  }

  /* Ticking changes the price, and nothing else. It does not touch the
     cart and it does not open the drawer -- the add-ons go up with the
     product when Add to cart is pressed. */
  document.addEventListener('change', function (event) {
    if (!event.target.matches || !event.target.matches('[data-nd-addon]')) return;
    var root = document.querySelector('[data-nd-product]') || document;
    retotal(root);
  });

  /* Colours and sizes, one to three at a time --------------------------
   *
   * The picker on top sets every item; the per-item pickers under a row for
   * two or three change one. The rows are repriced from the variants chosen
   * (two colours need not cost the same), their thumbnails restack, and the
   * checked row's list of ids is written to [data-nd-units] for the cart
   * drawer, which sends one line per variant. apply() then runs as for any
   * tier, so the button total, add-ons and sticky bar follow. */
  function setUpOptions(root) {
    var box = root.querySelector('[data-nd-options]');
    if (!box) return;
    var dataEl = box.querySelector('[data-nd-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var byId = {};
    variants.forEach(function (v) { byId[v.id] = v; });

    var sample = box.getAttribute('data-money-zero') || '$0';
    var savePrefix = box.getAttribute('data-save-prefix') || 'Save';
    var unitsInput = root.querySelector('[data-nd-units]');
    var valueEl = box.querySelector('[data-nd-option-value]');
    var swatches = [].slice.call(box.querySelectorAll('[data-nd-swatch]'));
    var radios = [].slice.call(box.querySelectorAll('[data-nd-tier]'));

    var first = box.querySelector('[data-nd-swatch].is-on') || swatches[0];
    var start = first ? Number(first.getAttribute('data-nd-swatch')) : variants[0].id;
    var units = [start, start, start];

    function render() {
      var checked = box.querySelector('[data-nd-tier]:checked') || radios[0];
      var allSame = units.every(function (id) { return id === units[0]; });

      swatches.forEach(function (sw) {
        var on = allSame && Number(sw.getAttribute('data-nd-swatch')) === units[0];
        sw.classList.toggle('is-on', on);
        sw.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      radios.forEach(function (radio) {
        var q = Number(radio.getAttribute('data-nd-quantity-value')) || 1;
        var wrap = radio.closest('[data-nd-tier-wrap]');
        var chosen = units.slice(0, q).map(function (id) { return byId[id]; });
        var total = 0, was = 0, available = true;
        chosen.forEach(function (v) {
          total += v.price;
          was += v.compare > v.price ? v.compare : v.price;
          if (!v.available) available = false;
        });
        /* Free gifts on this pack count towards the saving, as in Liquid. */
        var gift = Number(radio.getAttribute('data-nd-gift-cents')) || 0;
        if (gift > 0) {
          if (was < total) was = total;
          was += gift;
        }
        var save = was - total;

        radio.value = String(chosen[0].id);
        radio.setAttribute('data-nd-variant-value', String(chosen[0].id));
        radio.setAttribute('data-nd-total-cents', String(total));
        radio.setAttribute('data-nd-total-value', formatMoney(total, sample));
        radio.setAttribute('data-nd-was-cents', String(save > 0 ? was : 0));
        radio.setAttribute('data-nd-was-value', save > 0 ? formatMoney(was, sample) : '');
        radio.setAttribute('data-nd-media-id', String(chosen[0].media || ''));
        radio.disabled = !available;

        if (wrap) {
          var t = wrap.querySelector('[data-nd-row-total]');
          var w = wrap.querySelector('[data-nd-row-was]');
          var sv = wrap.querySelector('[data-nd-row-save]');
          if (t) t.textContent = formatMoney(total, sample);
          if (w) { w.textContent = formatMoney(was, sample); w.hidden = save <= 0; }
          if (sv) { sv.textContent = savePrefix + ' ' + formatMoney(save, sample); sv.hidden = save <= 0; }
          var ea = wrap.querySelector('[data-nd-row-each]');
          if (ea) {
            var word = ea.getAttribute('data-each-word') || ea.textContent.replace(/^[^a-zA-Z]*[\d.,]+\s*/, '');
            ea.setAttribute('data-each-word', word);
            ea.textContent = formatMoney(Math.round(total / q), sample) + ' ' + word;
            ea.hidden = q < 2;
          }

          var imgs = wrap.querySelectorAll('[data-nd-stack] img');
          for (var i = 0; i < imgs.length; i++) {
            var v = chosen[i];
            if (v && v.image && imgs[i].getAttribute('data-src-now') !== v.image) {
              imgs[i].removeAttribute('srcset');
              imgs[i].src = v.image;
              imgs[i].setAttribute('data-src-now', v.image);
            }
          }

          wrap.querySelectorAll('[data-nd-unit-variant]').forEach(function (btn) {
            var u = Number(btn.getAttribute('data-nd-unit')) - 1;
            var on = Number(btn.getAttribute('data-nd-unit-variant')) === units[u];
            btn.classList.toggle('is-on', on);
            btn.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          wrap.classList.toggle('is-open', radio === checked);
        }
      });

      var q = Number(checked.getAttribute('data-nd-quantity-value')) || 1;
      var names = units.slice(0, q).map(function (id) { return byId[id].title; });
      if (valueEl) {
        valueEl.textContent = allSame || q === 1 ? byId[units[0]].title : names.join(', ');
      }
      if (unitsInput) unitsInput.value = q > 1 ? units.slice(0, q).join(',') : '';
      apply(root, checked);
    }

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        if (sw.disabled) return;
        var id = Number(sw.getAttribute('data-nd-swatch'));
        units = [id, id, id];
        render();
        var checked = box.querySelector('[data-nd-tier]:checked');
        if (checked) checked.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    box.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-nd-unit-variant]');
      if (!btn || btn.disabled) return;
      var u = Number(btn.getAttribute('data-nd-unit')) - 1;
      units[u] = Number(btn.getAttribute('data-nd-unit-variant'));
      render();
    });

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { render(); });
    });

    render();
  }

  function init(root) {
    if (!root || root.ndProductReady) return;
    root.ndProductReady = true;

    var radios = root.querySelectorAll('[data-nd-tier]');
    if (!radios.length) return;

    if (root.querySelector('[data-nd-options]')) {
      setUpOptions(root);
      return;
    }

    for (var i = 0; i < radios.length; i++) {
      radios[i].addEventListener('change', function (event) {
        apply(root, event.currentTarget);
      });
    }

    apply(root, root.querySelector('[data-nd-tier]:checked'));
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-nd-product]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

/*
 * Media: thumbs drive the stage.
 *
 * The thumbs are real anchors to their slide, so with no JavaScript they
 * still work -- the browser jumps to the slide. That jump also scrolls the
 * page, which is why this takes over when it can: same target, but the stage
 * scrolls and the page stays put.
 *
 * The active thumb is driven by an observer on the slides rather than by the
 * click, so a swipe on a phone keeps the strip in step.
 */
(function () {
  function setUp(root) {
    var stage = root.querySelector('[data-nd-stage]');
    var thumbsTrack = root.querySelector('[data-nd-thumbs]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-nd-thumb]'));
    var slides = [].slice.call(root.querySelectorAll('[data-nd-slide]'));
    if (!stage || !thumbs.length) return;

    function mark(index) {
      var activeThumb = null;

      for (var i = 0; i < thumbs.length; i++) {
        var on = String(i) === String(index);
        thumbs[i].classList.toggle('is-active', on);

        if (on) {
          thumbs[i].setAttribute('aria-current', 'true');
          activeThumb = thumbs[i];
        } else {
          thumbs[i].removeAttribute('aria-current');
        }
      }

      /* Keep the thumbnail rail following the active gallery slide.
       * Use the rail's own scrollLeft rather than scrollIntoView(), because
       * scrollIntoView can also move the page vertically on mobile Safari. */
      if (thumbsTrack && activeThumb) {
        var target =
          activeThumb.offsetLeft -
          ((thumbsTrack.clientWidth - activeThumb.offsetWidth) / 2);

        var max = Math.max(0, thumbsTrack.scrollWidth - thumbsTrack.clientWidth);
        target = Math.max(0, Math.min(max, target));

        var reduced =
          window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        thumbsTrack.scrollTo({
          left: target,
          behavior: reduced ? 'auto' : 'smooth'
        });
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (event) {
        var slide = slides[Number(thumb.dataset.ndThumb)];
        if (!slide) return;
        event.preventDefault();
        stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
        mark(thumb.dataset.ndThumb);
      });
    });

    if (!('IntersectionObserver' in window)) return;

    var seen = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('video');

          if (entry.isIntersecting) {
            mark(entry.target.dataset.ndSlide);

            /* Match the live-theme gallery behaviour:
             * when a video slide becomes the active/visible slide, play it
             * automatically. Mobile Safari only permits reliable autoplay
             * when the video is muted and plays inline, so enforce both here.
             *
             * Pause every other gallery video first so only the slide being
             * watched can run. We do NOT reset currentTime, therefore swiping
             * away pauses it and swiping back resumes from the same position. */
            root.querySelectorAll('[data-nd-slide] video').forEach(function (other) {
              if (other !== video && !other.paused) other.pause();
            });

            if (video) {
              video.muted = true;
              video.defaultMuted = true;
              video.playsInline = true;
              video.setAttribute('muted', '');
              video.setAttribute('playsinline', '');
              video.setAttribute('webkit-playsinline', '');

              var promise = video.play();
              if (promise && typeof promise.catch === 'function') {
                promise.catch(function () {
                  /* If the browser temporarily refuses autoplay during a
                     swipe/resize, the next observer activation will retry. */
                });
              }
            }
          } else {
            /* Leaving the video slide pauses it. currentTime is preserved so
               returning to that slide continues from where it stopped. */
            if (video && !video.paused) video.pause();
          }
        });
      },
      { root: stage, threshold: 0.6 }
    );

    slides.forEach(function (slide) {
      seen.observe(slide);
    });
  }

  document.querySelectorAll('[data-nd-media]').forEach(setUp);

  /* A colour or size brings its own photograph forward. The tier radio
     carries the variant's media id; the matching slide is scrolled into
     the stage. Packs share one picture and carry no id, so nothing moves. */
  function showVariantMedia(radio, behavior) {
    var mediaId = radio && radio.getAttribute('data-nd-media-id');
    if (!mediaId) return;
    document.querySelectorAll('[data-nd-media]').forEach(function (root) {
      var stage = root.querySelector('[data-nd-stage]');
      var slide = root.querySelector('[data-nd-slide][data-nd-media-id="' + mediaId + '"]');
      if (!stage || !slide) return;
      stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: behavior });
    });
  }

  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio.matches || !radio.matches('[data-nd-tier]')) return;
    showVariantMedia(radio, 'smooth');
  });

  /* On load too: the gallery opens on the product's first photo, which for
     a colour is often not the colour that is selected (the Forge Wallet
     opened on olive with Gunmetal chosen). */
  showVariantMedia(document.querySelector('[data-nd-tier]:checked'), 'auto');
})();

/*
 * Customer quotes: dots follow the track.
 *
 * Same shape as the gallery -- the dots move the scroller, and an observer on
 * the quotes moves the dots, so a swipe and a tap stay in step. Nothing here
 * starts a timer; the slider only ever moves because someone moved it.
 */
(function () {
  function setUp(root) {
    var track = root.querySelector('[data-nd-quotes-track]');
    var dots = [].slice.call(root.querySelectorAll('[data-nd-quote-dot]'));
    var quotes = [].slice.call(root.querySelectorAll('[data-nd-quote]'));
    if (!track || !dots.length) return;

    function mark(index) {
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', String(i) === String(index));
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var quote = quotes[Number(dot.dataset.ndQuoteDot)];
        if (!quote) return;
        track.scrollTo({ left: quote.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        mark(dot.dataset.ndQuoteDot);
      });
    });

    if (!('IntersectionObserver' in window)) return;

    var seen = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) mark(entry.target.dataset.ndQuote);
        });
      },
      { root: track, threshold: 0.6 }
    );

    quotes.forEach(function (quote) {
      seen.observe(quote);
    });
  }

  document.querySelectorAll('[data-nd-quotes]').forEach(setUp);
})();

/*
 * Add-ons: add one to the cart without leaving the page.
 *
 * Posting to /cart/add.js rather than submitting a form, because a form
 * submission navigates away and the whole point of an add-on here is that it
 * costs the buyer nothing to take. On success the button says so and the
 * header count is nudged, so the page confirms the thing that just happened.
 */
(function () {
  function setUp(root) {
    root.querySelectorAll('[data-nd-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.classList.contains('is-added') || button.disabled) return;
        button.disabled = true;

        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          /* One id, or several separated by commas -- the "add both" row
             passes two and the rest pass one, so both go through the same
             handler rather than a second copy that drifts from it. */
          body: JSON.stringify({
            items: button.getAttribute('data-nd-add').split(',').map(function (id) {
              return { id: Number(id), quantity: 1 };
            })
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('add failed');
            return response.json();
          })
          .then(function () {
            button.classList.add('is-added');
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            /* Dawn draws the count in a bubble in the header. If it is not
               there, nothing here needs to care. */
            var bubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
            if (bubble) bubble.textContent = cart.item_count;
          })
          .catch(function () {
            /* Leave the button usable so a failed add can be tried again,
               rather than silently looking done. */
            button.disabled = false;
          });
      });
    });
  }

  /* The bundles row uses the same [data-nd-add] buttons, so it gets the same
     handler rather than a second copy of this that drifts from it. */
  document.querySelectorAll('[data-nd-addons], [data-nd-bundles]').forEach(setUp);
})();

/*
 * The sticky bar.
 *
 * It owns no state. Its pills click the real tier radios, its button submits
 * the real form through the form attribute, and everything it displays is
 * read back from whichever radio is checked. A sticky bar that keeps its own
 * copy of the tier is a sticky bar that eventually disagrees with the page,
 * usually about the price, usually at checkout.
 */
(function () {
  var bar = document.querySelector('[data-nd-sticky]');
  if (!bar) return;

  /* Moved to the body before anything else.
   *
   * It is authored inside the product section, and that section has
   * overflow-x: clip -- so does #MainContent. Safari treats a clipped element
   * as the containing block for its fixed-position descendants, so bottom:0
   * resolved to the bottom of the section rather than the viewport and the
   * bar sat mid-page with the rest of the page scrolling underneath it.
   * Chrome does not do this, which is why every measurement taken here said
   * the bar was correctly at 689..844.
   *
   * Re-parenting to the body removes the question entirely: whatever any
   * ancestor does with overflow, clip, contain or transform, the bar's
   * containing block is the viewport. The submit button reaches the form
   * through its form attribute, which works across the document, so nothing
   * else has to change. */
  document.body.appendChild(bar);

  var radios = [].slice.call(document.querySelectorAll('.nd-tier__input'));
  var pills = [].slice.call(bar.querySelectorAll('[data-nd-sticky-tier]'));
  var thumbs = [].slice.call(bar.querySelectorAll('[data-nd-sticky-thumb]'));
  var total = bar.querySelector('[data-nd-sticky-total]');
  /* The pack bar needs its pills and the tiers they drive. The simple bar
     (colours, sizes, a single variant) has neither and only mirrors the
     buy box's total, so it carries on to the show/hide logic below. */
  var simple = bar.classList.contains('nd-sticky--simple');
  if (!simple && (!radios.length || !pills.length)) return;

  function render() {
    if (simple) {
      var live = document.querySelector('[data-nd-total]');
      if (total && live && live.textContent.trim()) total.textContent = live.textContent.trim();
      return;
    }
    var index = 0;
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) index = i;
    }

    var radio = radios[index];
    var tile = radio.closest('.nd-tier');
    /* data-nd-quantity-value, not data-qty. The tiles write the first and the
       bar was reading the second, so every tier showed one thumbnail. A
       missing attribute reads as null and Number(null || 1) is 1, which is a
       plausible answer and therefore a silent one. */
    var qty = Number(radio.getAttribute('data-nd-quantity-value') || 1);

    pills.forEach(function (pill, i) {
      pill.classList.toggle('is-on', i === index);
      pill.setAttribute('aria-pressed', i === index ? 'true' : 'false');
    });

    thumbs.forEach(function (thumb, i) {
      thumb.hidden = i >= qty;
    });

    /* Colour bundles: the bar shows the colours chosen, taken from the
       row's own stacked thumbnails. */
    var wrap = radio.closest('[data-nd-tier-wrap]');
    if (wrap) {
      var chosen = wrap.querySelectorAll('[data-nd-stack] img');
      thumbs.forEach(function (thumb, i) {
        var img = thumb.querySelector('img');
        if (img && chosen[i] && img.src !== chosen[i].src) {
          img.removeAttribute('srcset');
          img.src = chosen[i].src;
        }
      });
    }

    /* Lifted from the buy box's own total, not from the tier tile.
     *
     * The tile carries the price of the pack. The buy box carries the
     * price of the pack plus whatever add-ons are ticked, and that is the
     * number the button charges -- so reading the tile put two different
     * totals on one screen: $189 above the fold and $159 in the bar that
     * says Continue to checkout. Measured at every tier: 189/159,
     * 320/280, 450/390.
     *
     * Still lifted rather than recomputed, which was the right instinct
     * in the first place -- it just has to be lifted from the element
     * that already knows the answer. The tile stays as the fallback for
     * a page with no add-ons block on it. */
    var liveTotal = document.querySelector('[data-nd-total]');
    var tileTotal = tile && tile.querySelector('.nd-tier__total');
    var source = liveTotal || tileTotal;
    if (total && source) total.textContent = source.textContent.trim();
  }

  pills.forEach(function (pill, i) {
    pill.addEventListener('click', function () {
      if (!radios[i] || radios[i].disabled) return;
      radios[i].checked = true;
      radios[i].dispatchEvent(new Event('change', { bubbles: true }));

      /* Colour bundles: two or three items means choosing two or three
         colours, and those pickers live in the row. Take the reader back
         to it -- centred, so the open pickers are in view under the
         pinned header rather than behind it. */
      var qty = Number(pill.getAttribute('data-nd-sticky-qty')) || 1;
      if (bar.hasAttribute('data-nd-sticky-scroll') && qty > 1) {
        var wrap = radios[i].closest('[data-nd-tier-wrap]');
        if (wrap) {
          var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.requestAnimationFrame(function () {
            wrap.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
          });
        }
      }
    });
  });

  radios.forEach(function (radio) {
    radio.addEventListener('change', render);
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest || !event.target.closest('[data-nd-swatch], [data-nd-unit-variant]')) return;
    window.requestAnimationFrame(render);
  });

  /* And when an add-on is ticked. Deferred by a frame because the buy
     box's own handler is listening for the same event, and reading its
     total in the same task would read the value from before the tick. */
  document.addEventListener('change', function (event) {
    if (!event.target.matches || !event.target.matches('[data-nd-addon]')) return;
    window.requestAnimationFrame(render);
  });

  render();

  /* Shown once the real button has scrolled past.
   *
   * A scroll listener rather than an IntersectionObserver, which is the
   * opposite of the choice made everywhere else in this file and is
   * deliberate. An observer fires when a threshold is CROSSED, and a fast
   * scroll can take a small target from below the fold to above it without
   * the browser ever registering it inside -- no crossing, no callback, and
   * the bar never appears. Measured: the button 1286px above the viewport
   * with the bar still hidden.
   *
   * Position is a state, not an event, so it is read rather than subscribed
   * to. Throttled to a frame, and passive so it cannot delay a scroll. */
  var anchor = document.querySelector('[data-nd-submit]');
  if (!anchor) {
    bar.hidden = false;
    bar.classList.add('is-in');
    return;
  }

  bar.hidden = false;

  /* Reserve the bar's height at the foot of the document, or the last thing
     on the page sits under it and cannot be scrolled into view -- the footer
     here, and on a short screen the checkout button itself.
     
     Measured rather than hard-coded: the bar's height changes with the
     badges, the safe-area inset on an iPhone, and whether the pills wrap. */
  /* A real element in the flow, not padding on the body.
     
     Dawn's body is a flex column, and padding-bottom on it did not push the
     footer clear -- measured with the page at its true bottom, the country
     selector still sat 70px under the bar. A block appended to the document
     is pushed by nothing and defeats nothing: whatever the bar's height, the
     spacer matches it and the last real content ends above it. */
  /* Inside the footer, not after it.
   *
   * Appended to the body it sat below the footer and painted the body's own
   * colour, so the reserved height read as a bare strip under the page
   * rather than as part of it. Inside the footer it takes the footer's
   * background and the reservation becomes invisible, which is the whole
   * point of a spacer. */
  var spacer = document.createElement('div');
  spacer.className = 'nd-sticky__spacer';

  var host = document.querySelector('.footer') || document.querySelector('footer') || document.body;
  host.appendChild(spacer);

  function reserve() {
    /* Re-appended each time, not only once. Apps and Shopify's own banner
       add nodes to the end of the body after this runs, and a spacer that is
       no longer last stops holding the document open past whatever followed
       it. Moving an existing node is a no-op when it is already in place. */
    if (host.lastElementChild !== spacer) host.appendChild(spacer);
    spacer.style.height = bar.offsetHeight + 'px';
  }

  var queued = false;
  function place() {
    queued = false;
    bar.classList.toggle('is-in', anchor.getBoundingClientRect().bottom < 0);
  }

  function onScroll() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(place);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    reserve();
    onScroll();
  }, { passive: true });

  reserve();
  place();

  /* Late-loading apps can move the end of the document after first paint. */
  window.setTimeout(reserve, 1200);
  window.setTimeout(reserve, 4000);

  /* The bar's height changes when the tier changes -- a badge appears, a
     label wraps -- so the reservation is retaken then too. */
  radios.forEach(function (radio) {
    radio.addEventListener('change', reserve);
  });
})();


(function () {
  function initAutoMediaHeight(root) {
    var stage = root.querySelector('[data-nd-stage]');
    if (!stage || stage.dataset.ndAutoHeightReady === 'true') return;
    stage.dataset.ndAutoHeightReady = 'true';

    var slides = Array.prototype.slice.call(
      stage.querySelectorAll('[data-nd-slide]')
    );

    if (!slides.length) return;

    var resizeRaf = null;
    var settleTimer = null;

    function getActiveSlide() {
      var stageRect = stage.getBoundingClientRect();
      var stageCenter = stageRect.left + (stageRect.width / 2);

      var closest = slides[0];
      var smallest = Infinity;

      slides.forEach(function (slide) {
        var rect = slide.getBoundingClientRect();
        var slideCenter = rect.left + (rect.width / 2);
        var distance = Math.abs(slideCenter - stageCenter);

        if (distance < smallest) {
          smallest = distance;
          closest = slide;
        }
      });

      return closest;
    }

    function setHeight(slide) {
      if (window.innerWidth > 749) {
        stage.style.height = '';
        return;
      }

      if (!slide) return;

      var media = slide.querySelector('img, video');
      if (!media) return;

      var width = stage.clientWidth;
      if (!width) return;

      var mediaWidth = 0;
      var mediaHeight = 0;

      function applyHeight(w, h) {
        if (!w || !h) return;

        cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(function () {
          stage.style.height = Math.round(width * h / w) + 'px';
        });
      }

      if (media.tagName === 'VIDEO') {
        mediaWidth = media.videoWidth;
        mediaHeight = media.videoHeight;

        if (mediaWidth && mediaHeight) {
          applyHeight(mediaWidth, mediaHeight);
          return;
        }

        var poster = media.getAttribute('poster');
        if (poster) {
          var temp = new Image();
          temp.onload = function () {
            applyHeight(temp.naturalWidth, temp.naturalHeight);
          };
          temp.src = poster;
        }

        return;
      }

      mediaWidth = media.naturalWidth;
      mediaHeight = media.naturalHeight;

      if (mediaWidth && mediaHeight) {
        applyHeight(mediaWidth, mediaHeight);
      }
    }

    function updateSettled() {
      clearTimeout(settleTimer);

      /*
       * IMPORTANT:
       * Do not resize the stage continuously while the finger/momentum scroll
       * is moving it. Changing the gallery height during a horizontal swipe
       * makes iOS Safari re-layout the scroller mid-gesture and can cause the
       * "fast jump / skip slides" behaviour.
       */
      settleTimer = setTimeout(function () {
        setHeight(getActiveSlide());
      }, 120);
    }

    slides.forEach(function (slide) {
      var img = slide.querySelector('img');

      if (img) {
        if (img.complete) {
          // Initial measurement only.
          setTimeout(function () {
            setHeight(getActiveSlide());
          }, 0);
        } else {
          img.addEventListener('load', function () {
            setHeight(getActiveSlide());
          }, { once: true });
        }
      }

      var video = slide.querySelector('video');
      if (video) {
        video.addEventListener('loadedmetadata', function () {
          if (slide === getActiveSlide()) setHeight(slide);
        });
      }
    });

    /*
     * Only update height AFTER native scrolling has settled.
     * This keeps the swipe fully native and smooth.
     */
    stage.addEventListener('scroll', updateSettled, { passive: true });

    if ('onscrollend' in stage) {
      stage.addEventListener('scrollend', function () {
        clearTimeout(settleTimer);
        setHeight(getActiveSlide());
      }, { passive: true });
    }

    root.querySelectorAll('[data-nd-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          setHeight(getActiveSlide());
        }, 380);
      });
    });

    window.addEventListener('resize', function () {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        setHeight(getActiveSlide());
      }, 80);
    }, { passive: true });

    setHeight(slides[0]);
    setTimeout(function () {
      setHeight(getActiveSlide());
    }, 250);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-nd-media]').forEach(initAutoMediaHeight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

/*
 * Mobile gallery: full-width slide lock.
 *
 * A video can start playing as soon as IntersectionObserver sees enough of
 * the slide. On iOS the native momentum scroll can stop a few pixels before
 * the exact snap point, which leaves a thin strip of the next slide visible.
 *
 * Keep every mobile slide exactly one stage wide, remove any flex gap, and
 * after native scrolling has fully settled, correct only the final few pixels.
 * Nothing runs continuously during the finger gesture, so this does not bring
 * back the fast/jumpy swipe problem fixed earlier.
 */
(function () {
  function setUp(root) {
    var stage = root.querySelector('[data-nd-stage]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-nd-slide]'));
    if (!stage || !slides.length || stage.dataset.ndFullWidthReady === 'true') return;

    stage.dataset.ndFullWidthReady = 'true';

    var timer = null;
    var correcting = false;

    function mobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function applyGeometry() {
      if (!mobile()) {
        stage.style.removeProperty('gap');
        stage.style.removeProperty('column-gap');
        stage.style.removeProperty('scroll-snap-type');
        stage.style.removeProperty('overscroll-behavior-x');

        slides.forEach(function (slide) {
          slide.style.removeProperty('flex');
          slide.style.removeProperty('width');
          slide.style.removeProperty('max-width');
          slide.style.removeProperty('scroll-snap-align');
          slide.style.removeProperty('scroll-snap-stop');
        });
        return;
      }

      stage.style.setProperty('gap', '0px', 'important');
      stage.style.setProperty('column-gap', '0px', 'important');
      stage.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
      stage.style.setProperty('overscroll-behavior-x', 'contain');

      slides.forEach(function (slide) {
        slide.style.setProperty('flex', '0 0 100%', 'important');
        slide.style.setProperty('width', '100%', 'important');
        slide.style.setProperty('max-width', '100%', 'important');
        slide.style.setProperty('scroll-snap-align', 'start', 'important');
        slide.style.setProperty('scroll-snap-stop', 'always', 'important');
      });
    }

    function nearestSlide() {
      var left = stage.scrollLeft;
      var best = slides[0];
      var distance = Infinity;

      slides.forEach(function (slide) {
        var target = slide.offsetLeft - stage.offsetLeft;
        var d = Math.abs(target - left);
        if (d < distance) {
          distance = d;
          best = slide;
        }
      });

      return best;
    }

    function finishSnap() {
      if (!mobile() || correcting) return;

      var slide = nearestSlide();
      if (!slide) return;

      var target = slide.offsetLeft - stage.offsetLeft;
      var delta = Math.abs(stage.scrollLeft - target);

      /* Ignore sub-pixel rounding. Correct only a visible remainder. */
      if (delta <= 1) return;

      correcting = true;
      stage.scrollTo({
        left: target,
        behavior: 'auto'
      });

      requestAnimationFrame(function () {
        correcting = false;
      });
    }

    function scheduleSnap() {
      if (correcting || !mobile()) return;
      clearTimeout(timer);

      /* Wait until iOS momentum has really stopped before correcting. */
      timer = setTimeout(finishSnap, 150);
    }

    applyGeometry();

    stage.addEventListener('scroll', scheduleSnap, { passive: true });

    if ('onscrollend' in stage) {
      stage.addEventListener('scrollend', function () {
        clearTimeout(timer);
        finishSnap();
      }, { passive: true });
    }

    window.addEventListener('resize', function () {
      clearTimeout(timer);
      applyGeometry();
      timer = setTimeout(finishSnap, 80);
    }, { passive: true });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-nd-media]').forEach(setUp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

